
<template>

  <div>
      <!--  查看我的人脸信息页面 -->
    <van-nav-bar
      class="backBox"
      title="我的面部信息"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content_box">
      <div class="main">
        <van-image
          width="263"
          height="197"
          fit="cover"
          :src="faceImg ? faceImg : ''"
        >
          <template v-slot:error>
            <van-image
              width="263"
              height="197"
              fit="cover"
              :src="require('../../assets/imgs/noFaceImg@2x.png')"
            >
            </van-image>
          </template>
        </van-image>

        <div class="title" v-if="faceImg">采集时间：{{ collectionTime }}</div>
        <div class="title_no" v-else>暂无人脸信息，请先采集</div>
      </div>
      <div class="operationBtn">
        <van-button round block type="info" @click="resetBindFace">{{
          faceImg ? '重新绑定' : '去采集'
        }}</van-button>
      </div>
    </div>
  </div>
</template>
<script>

import * as utils from '../../api/utils'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {

    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ]),
    ...mapGetters([
      'face'
    ]),
    faceJSONParse () {
      return JSON.parse(this.face)
    },
    faceImg () {
      return JSON.parse(this.face).avatar
    },
    collectionTime () {
      return utils.formatTimeYMDChinese(new Date(this.faceJSONParse.update_time))
    }
  },
  methods: {
    // 前往采集人脸
    goBindFace () {

    },
    resetBindFace () {
      this.$router.push('/announcements')
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  padding: 1rem;
  .main {
    text-align: center;
    margin-top: 1.625rem;
    .title {
      font-size: 1rem;
      color: #333;
      margin-top: 1.25rem;
    }
    .title_no {
      font-size: 1rem;
      color: #999;
      margin-top: 1.25rem;
    }
  }
  .operationBtn {
    margin: 2.25rem 0 0 0;
  }
}
</style>
